import { FieldMergeFunction, FieldReadFunction } from "@apollo/client";
/* 
In order for these function to work the Query has to return data in the following form:  
{
  total: number
  items: Array<any>
}

For usage check: marketplace-ops/app/src/state/typePolicies/typePolicies.ts
*/

export const readPaginatedResults = (
  existing: Parameters<FieldReadFunction>[0],
  { args }: Parameters<FieldReadFunction>[1],
  getNumberForPageSize: (pageSize: any) => number
) => {
  const { pageSize, page } = (args as any).pageRequest;
  const limit = getNumberForPageSize(pageSize);
  const offset = page * limit;
  const expectedPageSize = existing ? Math.min(limit, existing.total - offset) : limit;

  const requestedSlice = existing ? existing.items.slice(offset, offset + expectedPageSize) : [];

  if (Object.values(requestedSlice).length !== expectedPageSize) {
    return undefined;
  }

  return {
    total: existing.total,
    items: requestedSlice,
  };
};

export const mergePaginatedResults = (
  existing: Parameters<FieldMergeFunction>[0],
  incoming: Parameters<FieldMergeFunction>[1],
  { args }: Parameters<FieldMergeFunction>[2],
  getNumberForPageSize: (pageSize: any) => number
) => {
  const { pageSize, page } = (args as any).pageRequest;
  const limit = getNumberForPageSize(pageSize);
  const offset = page * limit;

  const merged = existing ? [...existing.items] : [];

  (incoming.items as unknown[]).forEach((item, i) => {
    merged[offset + i] = item;
  });

  return {
    total: incoming.total,
    items: merged,
  };
};
